import { render, staticRenderFns } from "./BaseComments.vue?vue&type=template&id=fb82b2ec&"
import script from "./BaseComments.vue?vue&type=script&lang=ts&"
export * from "./BaseComments.vue?vue&type=script&lang=ts&"
import style0 from "./BaseComments.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports